export enum ProfilePageTypeResults {
  individual = 'individual',
  corporation = 'corporation',
  applicationAdministrator = 'applicationAdministrator',
}
